<template>
  <dialog-reset height="75vh" top="5vh" width="80%" title="选择合同" :visible.sync="visible">
    <avue-crud v-if="visible" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :permission="permissionList" :before-open="beforeOpen" v-model="form" ref="crud" @row-update="rowUpdate"
      @row-save="rowSave" @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange"
      @row-dblclick="rowDblClick" @on-load="onLoad">
      <!-- <template slot-scope="{row, }" slot="station">
        <p>发站:{{ row.beginStation }}</p>
        <p>到站:{{ row.endStation }}</p>
      </template> -->
      <!-- <template slot-scope="{row, }" slot="intervalDate">
        <p>计划开始时间:{{ row.intervalStartTime }}</p>
        <p>计划结束时间:{{ row.intervalEndTime }}</p>
      </template> -->
      <template slot-scope="{row, }" slot="contractDate">
        <p>合同开始时间:{{ row.contractStartTime }}</p>
        <p>合同结束时间:{{ row.contractEndTime }}</p>
      </template>
    </avue-crud>
  </dialog-reset>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getContractList } from "@/views/railway-management/transportplan/api.js";
import { getSearchTimeConfig, rulesInput } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  name: 'SelectContract',
  data () {
    const that = this
    return {
      apiConfig: { getList:getContractList },
      defaultParams: {
        businessType: 1,
      },
      visible: false,
      query: {},
      option: {
        cancelHijack: true,
        maxHeight: '380',
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        menu: false,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchLabelWidth: 90,
        indexLabel: '序号',
        align: 'center',
        labelWidth: 135,
        column: [
        //   {
        //     label: '计划编号',
        //     prop: 'planNo',
        //     overHidden: true, // 表格超出隐藏
        //   },
        //   {
        //     label: '计划名称',
        //     prop: 'planName',
        //     overHidden: true, // 表格超出隐藏
        //     search: true,
        //   },
          {
            label: '合同编号',
            prop: 'contractNo',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            type: 'input',
            remote: true,
            readonly: true,
            maxlength: 30,
          },
          {
            label: '合同名称',
            prop: 'contractName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            type: 'input',
            remote: true,
            readonly: true,
            maxlength: 30,
          },
          {
            label: '客户',
            prop: 'custNo',
            overHidden: true, // 表格超出隐藏
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: '物资名称',
            prop: 'cargoName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            disabled: true,
            props: {
              label: 'varName',
              value: 'id'
            },
          },
          {
            label: '数量(吨)',
            prop: 'contractWeight',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            overHidden: true, // 表格超出隐藏
          },
          {
            label: '剩余量(吨)',
            prop: 'remainWeight',
            overHidden: true, // 表格超出隐藏
          },
        //   {
        //     label: '发到站',
        //     prop: 'station',
        //     overHidden: true, // 表格超出隐藏
        //     width: 150,
        //   },
        //   {
        //     label: '发站',
        //     prop: 'beginStation',
        //     hide: true,
        //     type: 'select',
        //     filterable: true,
        //     dicUrl: '/api/produce/station/select/distinct/page',
        //     props: {
        //       label: 'stationName',
        //       value: 'stationCode'
        //     },
        //   },
        //   {
        //     label: '到站',
        //     prop: 'endStation',
        //     hide: true,
        //     type: 'select',
        //     filterable: true,
        //     dicUrl: '/api/produce/station/select/distinct/page',
        //     props: {
        //       label: 'stationName',
        //       value: 'stationCode'
        //     },
        //   },
          {
            label: '合同起止时间',
            prop: 'contractDate',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            overHidden: true, // 表格超出隐藏
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            width:300
          },
          {
            label: '合同开始时间',
            prop: 'contractStartTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true,
            disabled: true,
            showColumn: false,
          },
          {
            label: '合同结束时间',
            prop: 'contractEndTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            hide: true,
            disabled: true,
            showColumn: false,
          },
        //   {
        //     ...getSearchTimeConfig('', { type: 'month' }),
        //     paramsKey: ["startTime", "endTime"],
        //   },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  },
  created () { },
  methods: {
    open (params = {}) {
      this.defaultParams = {
        ...this.defaultParams,
        businessType: 1,
        ...params,
      }
      this.query = {}
      this.visible = true
    },
    //  提交
    rowDblClick (item) {
      //  带出通知
      this.$emit('replace', item,)
      this.visible = false
    },

  },
}
</script>
<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: none;
}
</style>

